import { useState } from "react";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";
import SeoByAiModelContainer from "../SeoByAiModel/SeoByAiModelContainer";

const SeoByAiButtonContainer = ({ moneySiteId }: { moneySiteId?: number }) => {
    const { formatMessage } = useIntl();

    const [showModel, setShowModel] = useState(false);

    return (
        <>
            <Button onClick={() => setShowModel(true)}>
                {formatMessage({ id: "common.button.seoByAi" })}
            </Button>
            {showModel && (
                <SeoByAiModelContainer
                    showModel={showModel}
                    moneySiteId={moneySiteId}
                    handleCloseModel={() => setShowModel(false)}
                />
            )}
        </>
    );
};

export default SeoByAiButtonContainer;
